module.exports = __webpack_public_path__ + "img/create_module.png";